var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{directives:[{name:"scroll-to",rawName:"v-scroll-to",value:({
    el: _vm.target,
    duration: 1000
   }),expression:"{\n    el: target,\n    duration: 1000\n   }"}],staticClass:"show-more",attrs:{"href":"#"}},[_vm._v("\n    "+_vm._s(_vm.buttonText)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }